import { useContext, useEffect, useState } from "react";
// import LeftPanelImage from "app/uicomponents/microcomponents/LeftPanelImage";
import { ContactLeftPanelV2Items } from "app/Data/ContactLeftPanelItems";
import ContactLeftPanelMenuItem from "app/uicomponents/microcomponents/ContactLeftPanelMenuItem";
// import LeftPanelUserDetails from "app/uicomponents/microcomponents/LeftPanelUserDetails";
import DarkModeSelection from "../features/dashboard/components/DarkModeSelection";
// import { Skeleton } from "primereact/skeleton";
import { updatePanelItems } from "app/utils/utils";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";
import LeftPanelBrandingLogo from "app/uicomponents/microcomponents/LeftPanelBrandingLogo";
import { getObjectFromSessionStore, setObjectInSessionStore } from "app/utils/sessionStore";
import { makeRequest } from "app/utils/makeRequest";
import { Tooltip } from "primereact/tooltip";
import ContactProfileMenu from "./ContactProfileMenu";

const ContactLeftPanel = () => {
  const { isOpen, setIsOpen } = useContext(ContactProfileDetailsContext);
  const propStats = getObjectFromSessionStore("proposalStats");
  const [proposalStats, setProposalStats] = useState<any>(propStats ?? {});

  const updateProposalStats = () => {
    makeRequest("proposalStats")
      .get()
      .then((res) => {
        setProposalStats(res.data.data ?? {});
        setObjectInSessionStore("proposalStats", res.data.data ?? {});
      });
  };

  useEffect(() => {
    updateProposalStats();
  }, []);

  const ContactLeftPanelItemsUpdated = updatePanelItems(ContactLeftPanelV2Items, proposalStats);

  return (
    // Widths match the advisor sidebar, which drives them off the same two Tailwind keys
    // (Sidebar.tsx: `data ? "w-1/10" : "w-2/12"`) - 16.666667% expanded, 6.5% collapsed
    // per the custom width scale in tailwind.config.js. The spacer div and the fixed
    // aside have to carry the same class so the reserved and painted widths agree.
    <div className={`mb-4 relative z-[100] ${isOpen ? "w-2/12" : "w-1/10"}`}>
      <aside className={`h-[100vh] fixed z-100 ${isOpen ? "w-2/12" : "w-1/10"}`}>
        <nav
          className={`scrollbar-hide h-full flex flex-col justify-content-between overflow-y-auto pt-3 pb-4 dark:bg-blue-1100 ${
            isOpen ? "px-2" : "px-3"
          }`}
          style={{
            scrollbarWidth: "thin",
          }}
        >
          <div>
            <i
              className={`toggle-btn pi ${
                isOpen ? "pi-angle-double-left" : "pi-angle-double-right"
              } absolute top-[54px] right-0 z-10 cursor-pointer`}
              style={{ color: "#1581ED", fontSize: "19px" }}
              onClick={() => setIsOpen((prev: any) => !prev)}
            />
            <Tooltip target=".toggle-btn" position="right">
              {isOpen ? "Collapse" : "Expand"}
            </Tooltip>
            <LeftPanelBrandingLogo />
            {/* <LeftPanelImage /> */}
            {/* <h4
              className={`text-xl font-semibold !text-grayTexttext-center my-3 transition-opacity ${
                isOpen ? "opacity-100" : "opacity-0 hidden"
              }`}
            >
              {contactFirstName || contactLastName ? (
                `${contactFirstName} ${contactLastName}`
              ) : (
                <Skeleton width="100%" height="3rem" borderRadius="16px" className="mb-2" />
              )}
            </h4>
            <div className="mt-4 mb-6 flex justify-center">
              <div
                className={`${isOpen ? "w-full" : "!w-[3.5rem]"} h-[1px] bg-gray-500 rounded-md `}
              />
            </div> */}
            <div className="flex justify-center items-center">
              <ul
                className={`leftPanelUl conthrax-font text-base flex-1 text-center mb-3 ${
                  !isOpen ? "w-[36px]" : ""
                }`}
              >
                {ContactLeftPanelItemsUpdated.map(
                  (item: any) =>
                    !item.hide && (
                      <ContactLeftPanelMenuItem
                        key={item.id}
                        directTo={item.key}
                        name={item.name}
                        icon={item.icon}
                      />
                    ),
                )}
              </ul>
            </div>
          </div>
          <div className="flex-grow">
            <DarkModeSelection />
            <ContactProfileMenu />
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default ContactLeftPanel;
